import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useOnOpen } from "web_myplann/Inspiration/Hooks/useOnOpen";
import { RETIREMENT_LOAN_YEARS_SPAN } from "web_myplann/Inspiration/Retirement/constants";
import { getRetirementLoanDefaults } from "web_myplann/Inspiration/Retirement/Forms/getRetirementLoanDefaults";
import { getRetirementLoanFormSchema } from "web_myplann/Inspiration/Retirement/Forms/getRetirementLoanFormSchema";
import type { RetirementLoanFormModel } from "web_myplann/Inspiration/Retirement/Types/RetirementTypes";

type Params = {
	open: boolean;
	retirementYear: number;
};

export const useRetirementLoanForm = ({ open, retirementYear }: Params) => {
	const currentYear = new Date().getFullYear();

	const form = useForm<RetirementLoanFormModel>({
		resolver: zodResolver(getRetirementLoanFormSchema(currentYear)),
		defaultValues: getRetirementLoanDefaults(retirementYear, currentYear),
	});

	useOnOpen(open, () =>
		form.reset(getRetirementLoanDefaults(retirementYear, currentYear)),
	);

	return {
		...form,
		currentYear,
		lastYear: currentYear + RETIREMENT_LOAN_YEARS_SPAN,
	};
};
